import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import TipoDeTramite from './TipoDeTramite';




interface TipoDeTramiteTableProps {
  data: TipoDeTramite[];
  columns: TableColumn<TipoDeTramite>[];
  customStyles: Record<string, any>;
}

const TipoDeTramiteTable: React.FC<TipoDeTramiteTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<TipoDeTramite>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default TipoDeTramiteTable;